import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()
export class GestionService {
    constructor(private readonly _http: HttpClient) {}

    // MANTENIMIENTO PRODUCTOS
    public getProductos(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Producto/GetAllConFiltro', filters);
    }

    public getProductosIdioma(productoId) {
        return this._http.get<any>(environment.apiEndpoint + '/Producto/GetAllProductoIdioma?productoId=' + productoId);
    }

    public getProducto(productoId) {
        return this._http.get<any>(environment.apiEndpoint + '/Producto/GetById?productoId=' + productoId);
    }

    public createProducto(producto) {
        return this._http.post<any>(environment.apiEndpoint + '/Producto/', producto);
    }

    public createProductoIdioma(producto) {
        return this._http.post<any>(environment.apiEndpoint + '/Producto/InsertProductoIdioma/', producto);
    }

    public updateProducto(producto) {
        return this._http.put<any>(environment.apiEndpoint + '/Producto/', producto);
    }

    public deleteProducto(productoId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Producto/?id=' + productoId);
    }

    public deleteProductoIdioma(productoId, idiomaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Producto/DeleteProductoIdioma/?productoId=' + productoId +'&idiomaId=' + idiomaId);
    }

    // MANTENIMIENTO MARCAS
    public getMarcas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Marca/GetAllConFiltro', filters)
    }

    public getMarcasPaisDenominacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/MarcaPaisDenominacion/GetAllConFiltro', filters);
    }

    public getMarca(marcaId) {
        return this._http.get<any>(environment.apiEndpoint + '/Marca/GetById?marcaId=' + marcaId)
    }

    public createMarca(marca) {
        return this._http.post<any>(environment.apiEndpoint + '/Marca/', marca);
    }

    public createMarcaPaisDenominacion(marcaPaisDenominacion) {
        return this._http.post<any>(environment.apiEndpoint + '/MarcaPaisDenominacion/', marcaPaisDenominacion);
    }

    public updateMarca(marca) {
        return this._http.put<any>(environment.apiEndpoint + '/Marca/', marca);
    }

    public updateMarcaPaisDenominacion(marcaPaisDenominacion) {
        return this._http.put<any>(environment.apiEndpoint + '/MarcaPaisDenominacion/', marcaPaisDenominacion);
    }

    public deleteMarca(marcaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Marca/?id=' + marcaId);
    }

    public deleteMarcaPaisDenominacion(marcaId, paisId, denominacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/MarcaPaisDenominacion/?marcaId='
            + marcaId + '&paisId=' + paisId + '&denominacionId=' + denominacionId);
    }

    // MANTENIMIENTO CAMPAÑAS
    public getCampanyas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAllConFiltro', filters);
    }

    public getCampanya(campanyaId) {
        return this._http.get<any>(environment.apiEndpoint + '/Campanya/GetById?campanyaId=' + campanyaId);
    }

    public createCampanya(campanya) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/', campanya);
    }

    public insertCampanyaMultiple(campanya) {
      return this._http.post<any>(environment.apiEndpoint + '/Campanya/InsertCampanyaMultiple', campanya);
    }

    public updateCampanya(campanya) {
        return this._http.put<any>(environment.apiEndpoint + '/Campanya/', campanya);
    }

    public deleteCampanya(campanyaId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Campanya/?id=' + campanyaId);
    }

    public createDesignacionesFincaPruebas(desFincaPruebas) {
        return this._http.post<any>(environment.apiEndpoint + '/Designacion/CreaDesignacionesFincaDePruebas', desFincaPruebas);
    }


    // MANTENIMIENTO DENOMINACIONES
    public getDenominaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getDenominacionesPais(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public getDenominacionById(denominacionId) {
        return this._http.get<any>(environment.apiEndpoint + '/Denominacion/GetById?denominacionId=' + denominacionId);
    }

    public createDenominacion(denominacion) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/', denominacion);
    }

    public updateDenominacion(denominacion) {
        return this._http.put<any>(environment.apiEndpoint + '/Denominacion/', denominacion);
    }

    public deleteDenominacion(denominacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/Denominacion/?id=' + denominacionId);
    }

    // ETIQUETAS
    public getDisenyoEtiquetas(filter) {
        return this._http.post<any>(environment.apiEndpoint + '/DisenyoEtiqueta/GetAllConFiltro', filter);
    }

    public getGrupoEtiquetas() {
        return this._http.get<any>(environment.apiEndpoint + '/GrupoEtiqueta/GetAll');
    }

    // PAÍS DENOMINACIÓN
    public getPaisesByDenominacionId(filter) {
        return this._http.post<any>(environment.apiEndpoint + '/PaisDenominacion/GetAllConFiltro', filter);
    }

    public getPaisDenominacionById(paisId, denominacionId) {
        return this._http.get<any>(environment.apiEndpoint + '/PaisDenominacion/GetById?paisId=' + paisId + '&denominacionId=' + denominacionId);
    }

    public createPaisDenominacion(paisDenominacion) {
        return this._http.post<any>(environment.apiEndpoint + '/PaisDenominacion/', paisDenominacion);
    }

    public updatePaisDenominacion(paisDenominacion) {
        return this._http.put<any>(environment.apiEndpoint + '/PaisDenominacion/', paisDenominacion);
    }

    public deletePaisDenominacion(paisId, denominacionId) {
        return this._http.delete<any>(environment.apiEndpoint + '/PaisDenominacion/?paisId=' + paisId + '&denominacionId=' + denominacionId);
    }

    // IMAGEN COLOR
    public getDenominacionImagenColor(denominacionId) {
        return this._http.get<any>(environment.apiEndpoint + '/Denominacion/GetDisenyoCertificadoBlobById?id=' + denominacionId);
    }

    public updateDenominacionImagenColor(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/AsociaDisenyoCertificadoBlob', filters);
    }

    // GRUPOS DE ETIQUETA
    public getGruposEtiqueta(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/GrupoEtiqueta/GetAllConFiltro', filters);
    }

    public updateGruposEtiquetaDenominacion(grupoEtiqueta) {
        return this._http.put<any>(environment.apiEndpoint + '/GrupoEtiqueta/UpdateGrupoEtiquetaDenominacion', grupoEtiqueta);
    }

    public updateGruposEtiquetaPaisDenominacion(grupoEtiqueta) {
        return this._http.put<any>(environment.apiEndpoint + '/GrupoEtiqueta/UpdateGrupoEtiquetaPaisDenominacion', grupoEtiqueta);
    }

    public deleteGruposEtiquetaPaisDenominacion(grupoEtiqueta) {
        return this._http.delete<any>(environment.apiEndpoint + '/GrupoEtiqueta/DeleteGrupoEtiquetaPaisDenominacion/?grupoEtiquetaId='
            + grupoEtiqueta.grupoEtiquetaId + '&paisId=' + grupoEtiqueta.paisId + '&denominacionId=' + grupoEtiqueta.denominacionId);
    }

    public updateGruposEtiquetaMarcaPaisDenominacion(grupoEtiqueta) {
        return this._http.put<any>(environment.apiEndpoint + '/GrupoEtiqueta/UpdateGrupoEtiquetaMarcaPaisDenominacion', grupoEtiqueta);
    }

    public deleteGruposEtiquetaMarcaPaisDenominacion(grupoEtiqueta) {
        return this._http.delete<any>(environment.apiEndpoint + '/GrupoEtiqueta/DeleteGrupoEtiquetaMarcaPaisDenominacion/?grupoEtiquetaId='
            + grupoEtiqueta.grupoEtiquetaId + '&marcaId=' + grupoEtiqueta.marcaId +
                '&paisId=' + grupoEtiqueta.paisId + '&denominacionId=' + grupoEtiqueta.denominacionId);
    }

    // PROTECCIÓN
    public getProtecciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    public createOrUpdateProteccion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/InsertUpdateDenominacionProteccion', filters);
    }

    public deleteProteccion(id) {
        return this._http.delete<any>(environment.apiEndpoint + '/Denominacion/DeleteDenominacionProteccion?id=' + id);
    }
}
